import Vue from "vue";
import Vuetify, { VSnackbar, VBtn, VIcon } from "vuetify/lib";
import VuetifyToast from 'vuetify-toast-snackbar'
//import "vuetify/dist/vuetify.min.css";
//import "vuetify/src/styles/main.sass";
//import colors from "vuetify/lib/util/colors";
import rowingIcon from '@/components/icons/rowing.vue'
import tenants from '@/data/tenants.config'
const tenant = tenants.current();

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  }
});


const vuetifyInstance = new Vuetify({
  icons: {
    iconfont: "fa",
    values: {
      rowing: { // name of our custom icon
        component: rowingIcon, // our custom component
      },
    }
  },
  theme: {
    themes: {
      light: tenant.theme,
      Zlight: {
        primary: "#F46524",
        secondary: '#008AFF', // <-- new
        accent: '#005398',
        green: '#00B46E',
        gradient: '#FFC107'
      },
      dark: {
        primary: "#F46524",
        secondary: '#24b2f4',
        accent: '#005398',
        green: '#00B46E',
        gradient: '#FFC107'
      },
      custom: {
          primary: '#9c27b0',
          secondary: '#4caf50',
          accent: '#3f51b5',
          error: '#e91e63',
          warning: '#f44336',
          info: '#03a9f4',
          success: '#8bc34a'
      }
    },
    options: {
      customProperties: true // generate css variables
    },
  }
});

Vue.use(VuetifyToast, { $vuetify: vuetifyInstance.framework });

export default vuetifyInstance;